// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_8f80b68e","outerContainer":"_4a1b7fc0","secondaryToolbar":"_08e545f9","doorHangerRight":"_58e74f0f","toolbarContainer":"_35a93258","toolbarViewerMiddle":"cfcb5237","progressBar":"_908bf43b","back-to-application":"a2d51624","root":"_649a6fc5","scale":"ed3ab4dc","rangeEndPointContainer":"_997786fd","rangeEndPointTextContainer":"c125e68b","rangeEndPointText":"_6d635064","pointContainer":"_6a44d380","bottom":"e942a357","top":"fdb810d9","subscriptionContainer":"bea86fde"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/TestResultsScale/index.styl
// module id = 5050
// module chunks = 39